// lead-documents.ts

import { Component, OnInit, OnDestroy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { Document } from '../document/document';
import { MODULE_SEQ } from '../../../core/shared/models/picklist.model';

@Component({
  selector: 'app-lead-documents',
  standalone: true,
  imports: [CommonModule, Document, TranslatePipe],
  templateUrl: './lead-documents.html',
  styleUrl: './lead-documents.css',
})
export class LeadDocuments implements OnInit, OnDestroy {
  // =====================================
  // VARIABLES
  // =====================================

  leadSeq: number | null = null;

  isViewMode = false;

  // =====================================
  // MODULE SEQ
  // =====================================

  readonly LEADS_MODULE_SEQ = MODULE_SEQ.LEADS;
  private subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  // =====================================
  // INIT
  // =====================================

  ngOnInit(): void {
    // lead seq
    this.subs.push(
      this.route.paramMap.subscribe((params) => {
        const id = params.get('id');

        this.leadSeq = id ? +id : null;
      }),
    );

    // view mode
    this.subs.push(
      this.route.queryParamMap.subscribe((q) => {
        this.isViewMode = q.get('mode') === 'view';
      }),
    );
  }

  // =====================================
  // DESTROY
  // =====================================

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  // =====================================
  // NEXT
  // =====================================

  goNext(): void {
    if (!this.leadSeq) {
      return;
    }

    this.router.navigate(
      ['/add-new-leads/add-terms', this.leadSeq],

      {
        queryParams: this.isViewMode ? { mode: 'view' } : {},
      },
    );
  }

  // =====================================
  // BACK
  // =====================================

  goBack(): void {
    if (!this.leadSeq) {
      return;
    }

    this.router.navigate(
      ['/add-new-leads', this.leadSeq],

      {
        queryParams: this.isViewMode ? { mode: 'view' } : {},
      },
    );
  }
}
